import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const base_url = process.env.REACT_APP_API_URL;

export default function Deposit() {
  const token = localStorage.getItem("token");
  const [amount, setAmount] = useState("");
  const [method, setMethod] = useState("upi");
  const [payment, setPayment] = useState(null);
  const [txid, setTxid] = useState("");
  const [proofImage, setProofImage] = useState(null);

  useEffect(() => {
    fetchPayment();
  }, []);

  const fetchPayment = async () => {
    try {
      const res = await axios.get(`${base_url}/api/payment-details`, {
        headers: { Authorization: token },
      });

      if (res.data.success) {
        setPayment(res.data.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const copyText = (text) => {
    navigator.clipboard.writeText(text);
    toast.success("Copied");
  };

  const submitDeposit = async () => {
    try {
      const data = new FormData();

      data.append("amount", amount);
      data.append("method", method);
      data.append("transaction_id", txid);

      if (proofImage) {
        data.append("proof", proofImage);
      }

      const res = await axios.post(`${base_url}/api/create-deposit`, data, {
        headers: {
          Authorization: token,
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success(res.data.message);

      setAmount("");
      setTxid("");
      setProofImage(null);
    } catch (err) {
      toast.error("Deposit failed");
    }
  };

  const quickAmounts = [100, 350, 1000, 5000, 10000, 20000];

  return (
    <div className="depositPage">
      <div className="depositCard">
        <h3 className="title">Deposit Funds</h3>

        {/* PAYMENT METHODS */}

        <div className="methodRow">
          <div
            className={`methodBox ${method === "upi" ? "active" : ""}`}
            onClick={() => setMethod("upi")}
          >
            UPI
          </div>

          <div
            className={`methodBox ${method === "bank" ? "active" : ""}`}
            onClick={() => setMethod("bank")}
          >
            Bank
          </div>

          <div
            className={`methodBox ${method === "usdt" ? "active" : ""}`}
            onClick={() => setMethod("usdt")}
          >
            USDT
          </div>
        </div>

        {/* PAYMENT DETAILS */}

        {payment && (
          <div className="paymentBox">
            {/* UPI */}

            {method === "upi" && (
              <>
                {payment.qr_image && (
                  <img
                    src={`${base_url}/uploads/${payment.qr_image}`}
                    className="qr"
                    alt="qr"
                  />
                )}

                <p className="payText">
                  UPI ID : <b>{payment.upi_id}</b>
                  <i
                    className="bi bi-copy copyIcon"
                    onClick={() => copyText(payment.upi_id)}
                  ></i>
                </p>
              </>
            )}

            {/* BANK */}

            {method === "bank" && (
              <>
                <p className="payText">
                  Bank : <b>{payment.bank_name}</b>
                  <i
                    className="bi bi-copy copyIcon"
                    onClick={() => copyText(payment.bank_name)}
                  ></i>
                </p>

                <p className="payText">
                  Account : <b>{payment.account_no}</b>
                  <i
                    className="bi bi-copy copyIcon"
                    onClick={() => copyText(payment.account_no)}
                  ></i>
                </p>

                <p className="payText">
                  IFSC : <b>{payment.ifsc}</b>
                  <i
                    className="bi bi-copy copyIcon"
                    onClick={() => copyText(payment.ifsc)}
                  ></i>
                </p>
              </>
            )}

            {/* USDT */}

            {method === "usdt" && (
              <p className="payText">
                USDT Address : <b>{payment.usdt_address}</b>
                <i
                  className="bi bi-copy copyIcon"
                  onClick={() => copyText(payment.usdt_address)}
                ></i>
              </p>
            )}
          </div>
        )}

        {/* AMOUNT */}

        <h4 className="amountTitle">Deposit Amount</h4>

        <div className="amountGrid">
          {quickAmounts.map((a) => (
            <div
              key={a}
              className={`amountBox ${amount == a ? "active" : ""}`}
              onClick={() => setAmount(a)}
            >
              ₹ {a >= 1000 ? a / 1000 + "K" : a}
            </div>
          ))}
        </div>

        <input
          className="amountInput"
          placeholder="Enter amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />

        <input
          className="amountInput"
          placeholder="Enter Transaction ID"
          value={txid}
          onChange={(e) => setTxid(e.target.value)}
        />

        <input
          type="file"
          className="amountInput"
          accept="image/*"
          onChange={(e) => setProofImage(e.target.files[0])}
        />

        <button
          className="depositBtn"
          disabled={!amount || !txid}
          onClick={submitDeposit}
        >
          Deposit
        </button>
      </div>
    </div>
  );
}
